import { Guid } from '@ef-carbon/primitive';
import Type from './Type';
export class LinkDirect {
    constructor({id, redirect}) {
        this.type = Type.Direct;
        this.id = new Guid(id);
        this.redirect = redirect ? new Guid(redirect) : undefined;
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.writable = false;
        descriptors.type.configurable = false;
        descriptors.id.configurable = false;
        descriptors.redirect.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export {
    LinkDirect as Direct
};
export const klass = LinkDirect;
export default LinkDirect;    //# sourceMappingURL=Direct.js.map
